/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotChatService
 */

/**
 *  Represents a Thread with an ID (after insertion)
 */

/**
 *  Response for starting a new chat session.
 *  Contains the full thread information.
 */

export const startChatRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotChatService',
  rpcName: 'startChat',
  auth: 'app',
  fingerprint: 'ifxT6Ihb2X7DMrTL1q2FGyuUlCfe1Jx3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAuthTokenRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotChatService',
  rpcName: 'createAuthToken',
  auth: 'app',
  fingerprint: 'KwlurV9hquFinkXx4JxSh_nMVnvWTrE8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};